import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class VizsgaHelyeDto extends IdentifiableDto {
	/**
	 * @module VizsgaHelyeDto
	 */
	constructor() {
		super();
		/** @type {string} */
		this.nev = null;
		/** @type {string} */
		this.rovid = null;
	}

	/**
	 * @typedef {Object} _VizsgaHelyeDtoProps
	 * @property {string} nev
	 * @property {string} rovid
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _VizsgaHelyeDtoProps} VizsgaHelyeDtoProps
	 */
	/**
	 *
	 * @param {VizsgaHelyeDtoProps} props
	 * @returns {VizsgaHelyeDto}
	 */
	setup(props) {
		super.setup(props);
		this.nev = props.nev;
		this.rovid = props.rovid;
		return this;
	}
}

export default VizsgaHelyeDto;
